import { t } from '@hefe/i18n';
import { UserInvitationLink } from '@hefe/models';
import { ModalsSlice, UsersSlice } from '@hefe/store';
import { formatDateTime } from '@hefe/utils';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { environment } from '../../../../../environments/environment';
import { useAppDispatch } from '../../../../store/store';
import CustomTable from '../../../core/components/table/custom-table.component';
import InvitationLinkComponent from '../../components/inivation-link/invitation-link.component';
import AddInvitationLinkForm from '../../forms/add-invitation-link/add-invitation-link.form';

export default function InvitationLinksPage() {
  const dispatch = useAppDispatch();

  const [loading, setLoading] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const invitationLinks = useSelector(UsersSlice.usersInvitationLinksSelector);

  useEffect(() => {
    fetchInvitationLinks();
  }, []);

  const fetchInvitationLinks = () => {
    setLoading(true);

    dispatch(UsersSlice.fetchInvitationLinks())
      .unwrap()
      .catch(() => undefined)
      .finally(() => {
        setLoading(false);
      });
  };

  const deleteInvitationLink = (id: number) => {
    setDeleting(true);

    const link = invitationLinks.find((link) => link.id === id);

    if (!link) {
      return;
    }

    dispatch(UsersSlice.deleteInvitationLink(link))
      .unwrap()
      .catch(() => undefined)
      .finally(() => {
        setDeleting(false);
      });
  };

  return (
    <CustomTable
      name={'users-invitation-links'}
      rowKey={'id'}
      loading={loading}
      onRowClick={(link: UserInvitationLink) => {
        dispatch(
          ModalsSlice.modalsActions.openModal({
            title: t('users.invitation_links.singular'),
            component: <InvitationLinkComponent link={link} />,
            closable: true,
            hideOkButton: true,
          })
        );
      }}
      columns={[
        {
          key: 'url',
          title: t('url'),
          default: true,
          render: (link: UserInvitationLink) => {
            return environment.frontendUrl + '/#/register/' + link.token;
          },
        },
        {
          key: 'valid_until',
          title: t('users.invitation_links.valid_until'),
          dataIndex: 'valid_until',
          sortType: 'date',
          default: true,
          render: (valid_until: string, record: any) => {
            return formatDateTime(valid_until);
          },
        },
        {
          key: 'team',
          title: t('users.invitation_links.valid_for'),
          dataIndex: 'team_name',
          sortType: 'string',
          showFilter: true,
          default: true,
          render: (team_name: string, record: any) => {
            return team_name ?? t('users.invitation_links.valid_for_all_teams');
          },
        },
      ]}
      dataSource={invitationLinks}
      addForm={{
        formId: 'add-invitation-link-form',
        title: t('users.invitation_links.generate'),
        component: <AddInvitationLinkForm />,
      }}
      deleteAction={{
        action: (keys: any[]) =>
          keys[0] ? deleteInvitationLink(keys[0]) : null,
        loading: deleting,
      }}
    />
  );
}
